import React from 'react';
import { Col, FormGroup, Label, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify'
import ImageWidget from './ImageWidget'

const DocumentDetails = (props) => {

  const handleFileUpload = (event) => {
    let currentFiles = event.target.files;
    if(currentFiles.length > 4) {
      toast.error("Maximum of 4 files can be uploaded");
      return;
    }
    const types = ['image/png',  'image/jpeg', 'application/pdf']
    for(let file of currentFiles) {
      if(types.every(type => file.type !== type)) {
        toast.error(`${file.type} is not a supported format`);
        return;
      }
    }
    let files = [];
    for(let file of currentFiles) {
      files.push({filename: file.name, uploaded: false})
    }
    props.setFieldValue("filesList", [...props.uploadedFiles, ...files])
    props.setFieldValue("files", currentFiles);
  }

  return (
    <React.Fragment>
      <Col md="4">
        <FormGroup>
          <Label>Title of Documents</Label>
          <Input type="text"
            name="title"
            value={props.title}
            onChange={props.handleChange}
          />
          {props.errors.title && props.touched.title && <div id="feedback" className="text-danger">{props.errors.title}</div>}
        </FormGroup>
      </Col>
      <Col md="4">
        <FormGroup>
          <Label>Description</Label>
          <Input type="textarea" 
            name="description"
            value={props.description}
            onChange={props.handleChange}
          />
          {props.errors.description && props.touched.description && <div id="feedback" className="text-danger">{props.errors.description}</div>}
        </FormGroup>
      </Col>
      <Col md="4">
        <FormGroup>
          <Label className="w-100">Upload Document</Label>
          <Button onClick={() => this.fileInput.click()}>Upload files</Button>
          <input style={{display: "none"}} 
            type="file"
            name="files"
            ref={fileInput => this.fileInput = fileInput}
            onChange={handleFileUpload}
            // onChange={(event) => {
            //   let files = [];
            //   for(let file of event.target.files) {
            //     files.push({filename: file.name, uploaded: false})
            //   }
            //   props.setFieldValue("filesList", [...props.uploadedFiles, ...files])
            //   props.setFieldValue("files", event.currentTarget.files);
            // }}
            multiple
          />
          <p className="text-muted">*Formats JPEG, PNG, PDF only.<br />
            Maximum 4 files are allowed</p>
          <ImageWidget files={props.filesList} 
            formType={props.formType}
            deleteImage={props.deleteImage}
          />
        </FormGroup>
      </Col>
    </React.Fragment>
  )
}

export default DocumentDetails;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/DocumentDetails.js